import ReactPaginate from "react-paginate";
import { useNavigate, useLocation } from "react-router-dom";
import Style from "./Paginator.module.scss";


export const Paginator = (props: {
    initalPage: number,
    pages: number,
    byClick?: boolean
    hrefBuilder?: (ageIndex: number,
                  pageCount: number,
                  selectedPage: number) => string

})=>
{
    const {
        pages,
        initalPage,
        byClick,
        hrefBuilder
    } = props;

    const router = useNavigate();
    const url = useLocation()

    if (pages === 1) {
        return null;
    }

    const pageCount = pages

    return <ReactPaginate
        hrefBuilder={hrefBuilder}
        key={initalPage-1 ?? "u"}
        initialPage={initalPage-1}
        className={`d-flex ${Style.Ul} justify-content-center align-content-center flex-wrap mb-0`}
        pageCount={pageCount}
        pageClassName={`${Style.Li} align-self-center ms-2 me-2`}
        pageLabelBuilder={(page)=> <span className={Style.href}>{page}</span>}
        activeClassName={Style.Active}
        nextClassName={`${Style.sipky} ${Style.right}`}
        previousClassName={`${Style.sipky}`}
        previousLabel={<span className={Style.span}>Předchozí</span>}
        nextLabel={<span className={Style.span}>Další</span>}
        onClick={(data) => {
            if (byClick && hrefBuilder) {
                router(hrefBuilder((data.nextSelectedPage ?? 0) + 1, pageCount, data.selected));
            }
            else
            {
                const l = url.pathname;
                let newSearch = "";
                if (l) {
                    const page = (data.nextSelectedPage ?? 0) + 1;
                    const params = new URLSearchParams(url.search);
                    if (page  > 1) {
                        params.set("page", `${page}`);
                    }
                    else
                    {
                        params.delete("page");
                    }
                    newSearch = params.toString();
                    if (newSearch) {
                        router(`${l}?${newSearch.replace(/^\?/, "")}`);
                    }
                    else {
                        router(`${l}`);
                    }
                }
            }
        }}

    />
}